var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoteWriteIcon = function SvgNoteWriteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12040_32121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0422 17.885L20.3222 7.60499C21.1032 6.82399 21.1032 5.55799 20.3222 4.77699L19.2002 3.65399C18.4192 2.87299 17.1532 2.87299 16.3722 3.65399L6.09118 13.935C5.94518 14.081 5.82318 14.249 5.72818 14.432L3.09818 19.528C2.65218 20.393 3.57918 21.321 4.44418 20.876L9.54318 18.25C9.72818 18.154 9.89618 18.032 10.0422 17.885Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12040_32121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgNoteWriteIcon as ReactComponent };
export default __webpack_public_path__ + "note-write-icon.svg";